import { useState } from "react";
import md5 from "md5";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

const MD5Hash = () => {
  const [input, setInput] = useState("");
  useTheme();
  const [hash, setHash] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);
    if (value) {
      setHash(md5(value));
    } else {
      setHash("");
    }
  };

  return (
    <>
      <HeaderSection toolId="md5Hash" />
      <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4 dark:text-white">
        <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
            <h1 className="text-2xl font-bold mb-2 flex items-center">
              <FontAwesomeIcon icon={faLock} className="mr-3" />
              MD5 Hash Generator
            </h1>
            <p className="opacity-90">
              Generate MD5 hashes from your input text
            </p>
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
              htmlFor="input"
            >
              Input Text
            </label>
            <textarea
              id="input"
              value={input}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Enter text to hash"
              rows={4}
            />
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
              htmlFor="hash"
            >
              MD5 Hash
            </label>
            <textarea
              id="hash"
              value={hash}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-100 font-mono"
              rows={4}
            />
          </div>
        </div>
      </div>
      <BottomSection toolId="md5Hash" />
    </>
  );
};

export default MD5Hash;